import { render, staticRenderFns } from "./SideNavMenu.vue?vue&type=template&id=41ba1bdf&scoped=true&"
import script from "./SideNavMenu.vue?vue&type=script&lang=js&"
export * from "./SideNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideNavMenu.vue?vue&type=style&index=0&id=41ba1bdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba1bdf",
  null
  
)

export default component.exports